import {
    getBrandIdFromUrlWithoutFallback,
    RING_CENTRAL_BRAND_ID,
} from '@ringcentral/rwc-branding/src/brand-info';
import { setBrandIdForConfig } from '@ringcentral/rwc-utils/src/config';

if (!('process' in globalThis)) {
    // eslint-disable-next-line no-console
    console.info('config getConfig: config initial');
}

setBrandIdForConfig(getBrandIdFromUrlWithoutFallback() || RING_CENTRAL_BRAND_ID);
